<template>
    <div class="avatar" :style="{width: size+'px', height: size+'px'}">
        <ResourceImg v-if="id" :id="id"/>
        <a-icon v-else type="user" :style="{fontSize: size/2+'px'}"></a-icon>
    </div>
</template>

<script>
    import ResourceImg from "./ResourceImg";

    export default {
        name: "UserAvatar",
        props: {
            id: String,
            size: Number,
        },
        components: {ResourceImg}
    }
</script>

<style scoped lang="less">
    .avatar {
        color: #777777;
        border-radius: 100%;
        border: 1px #ff5500 solid;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            width: 100%;
            height: 100%;
            border-radius: 100%;
        }
    }
</style>
